/* eslint-disable react/prop-types */
import React from 'react';
import { Center, Text } from '@chakra-ui/react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        console.log(error)
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        console.log(error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return <Center
                w='100%'
                h='91.5vh'
            ><Text>Something went wrong rendering the table.</Text></Center>;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;